import amplitude from "amplitude-js";

const PUBLIC_API_KEY = "c2b005a9b9100caa0a9d213702159511";
amplitude.getInstance().init(PUBLIC_API_KEY);

const logAmplitudeEvent = (e) => amplitude.getInstance().logEvent(e);

const logAmplitudeEventWithData = (e, data) =>
  amplitude.getInstance().logEvent(e, data);

export { amplitude, logAmplitudeEvent, logAmplitudeEventWithData };
